import shopProducts from '../data/shopProducts';

/** Rotate through the shop catalog so ads don’t feel stuck on the same items. */
export function pickAffiliateProducts(count = 3, salt = 0) {
  const list = shopProducts;
  if (!list.length) return [];

  const day = Math.floor(Date.now() / 86_400_000);
  const start = Math.abs(day + salt) % list.length;
  const out = [];
  for (let i = 0; i < count && i < list.length; i += 1) {
    out.push(list[(start + i) % list.length]);
  }
  return out;
}
